<template>
    <tbody>
        <tr v-for="item in items" :class="[selected.includes(item[checkboxKey]) ? 'alpha-indigo' : '']">
            <td v-if="hasCheckbox">
                <Checkbox
                    :modelValue="selected.includes(item[checkboxKey])"
                    @update:modelValue="newValue => selectOne(item[checkboxKey], newValue)"
                />
            </td>
            <td v-for="column in columns" style="max-width: 300px; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">
                <slot :column="column" :item="item">{{ item[column.name] }}</slot>
            </td>
            <td v-if="!config.settings.isStatic" style="width: 40px"></td>
        </tr>
    </tbody>
</template>

<script>
import Checkbox from "../../new/form/checkbox/AppCheckbox.vue";

export default {
    name: "BodyComponent",
    components: {Checkbox},
    emits: ['update:selected'],
    props: ['columns', 'items', 'hasCheckbox', 'selected', 'checkboxKey', 'config'],
    methods: {
        selectOne(value, checked) {
            let selected = this.selected;

            if (checked) {
                selected.push(value)
            } else {
                selected = selected.filter(selectedId => selectedId !== value);
            }

            this.$emit('update:selected', selected);
        },
        selectAll(checked){
            let selected = checked ? this.items.map(item => item[this.checkboxKey]) : [];

            this.$emit('update:selected', selected);
        }
    }
}
</script>

<style>
tr.alpha-indigo {
    background-color: #e8eaf6 !important;
}
</style>
